export default __webpack_public_path__ + "static/media/HS.a6f0c7d6.png";